import { Link } from 'react-router-dom';

export default function Footer() {
  const footerLinks = [
    {
      title: '快速导航',
      links: [
        { label: '首页', to: '/' },
        { label: '使用指南', to: '/category/guide' },
        { label: '功能解析', to: '/category/feature' },
        { label: '最新资讯', to: '/category/news' },
      ],
    },
    {
      title: '资源中心',
      links: [
        { label: '应用案例', to: '/category/case' },
        { label: '深度评测', to: '/category/review' },
        { label: '关于我们', to: '/about' },
      ],
    },
    {
      title: '联系方式',
      links: [
        { label: '邮箱：contact@18c.mic', to: '#' },
        { label: '电话：400-888-1818', to: '#' },
        { label: '地址：北京市朝阳区科技园路18号', to: '#' },
      ],
    },
  ];

  return (
    <footer className="bg-background-950 text-background-200">
      <div className="mx-auto px-4 md:px-6 max-w-[1400px] py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link
              to="/"
              className="flex items-center gap-2 text-background-50 font-bold text-xl whitespace-nowrap cursor-pointer hover:opacity-80 transition-opacity mb-4"
            >
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg text-sm font-extrabold">
                18
              </span>
              <span>18c.mic</span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              核心平台与资源入口，帮助您快速了解、上手使用18c.mic，最大化发挥平台潜力。
            </p>
          </div>
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h3 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">
                {group.title}
              </h3>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-10 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 18c.mic. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-500 hover:text-background-200 transition-colors cursor-pointer text-xs whitespace-nowrap" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-background-500 hover:text-background-200 transition-colors cursor-pointer text-xs whitespace-nowrap" rel="nofollow">
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}